// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"238":"7bb553c3","676":"7bb553c3"}[chunkId] + ".chunk.css";
};